(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('RegisterController', RegisterController)

	/** @ngInject */
	function RegisterController($state, UserService, HelperService, NotifyService, sweetAlert) {
		const vm = this;

		vm.showHidePwd = element => HelperService.showHidePwd(element);

		vm.submitRegisterForm = () => {
			let user = angular.copy(vm.registerForm);
			if (!user) return

			let params = {
				name: user.name,
				email: user.email,
				password: Encrypt.Hash(user.password).toString(),
				active: 1
			}

			HelperService.startLoading(".content-body", "Enviando seus dados");

			UserService
				.verifyRegister(params)
				.then(success => {
					HelperService.stopLoading(".content-body")

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					saveUser(params);
				}, error => {
					HelperService.stopLoading(".content-body")
					HelperService.errorCallback(error)
				})
		};

		init();

		function doLogin() {
			HelperService.startLoading(".content-body", "Fazendo login", true);

			UserService
				.login(vm.loginData)
				.then(() => {
					HelperService.stopLoading(".content-body");
					$state.go("app.home");
				}, error => {
					HelperService.stopLoading(".content-body");
					NotifyService.error(error);
				})
		}

		function saveUser(user) {
			UserService
				.post(user)
				.then(success => {
					HelperService.stopLoading(".content-body");

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					let config = {
						type: 'success',
						title: 'Parabéns!',
						text: 'Seu cadastro foi efetuado com sucesso!',
						confirmButtonText: 'Continuar',
						showCancelButton: false,
						allowOutsideClick: false,
						allowEscapeKey: false
					};

					vm.loginData.email = user.email;
					vm.loginData.password = user.password;

					sweetAlert
						.swal(config)
						.then(doLogin);
				}, error => {
					HelperService.stopLoading(".content-body");
					HelperService.errorCallback(error);
				})
		}

		function init() {
			vm.form = {};
			vm.loginData = {};
			vm.emailFormat = /\S+@\S+\.\S+/;
		}


	}
}());